<template>
    <div id="app">
        <router-view/>
        <QRCode v-show="codeShow"></QRCode>
    </div>
</template>
<script>
    import QRCode from './components/QRCode/QRCode'

    export default {
        name: 'App',
        components: {
            QRCode
        },
        data() {
            return {
                codeShow: true
            }
        },
        methods: {
            QRCodeShow() {
                if (this.$route.path === '/PhoneDetails') {
                    this.codeShow = false
                }
            },
            test() {
                this.$common.get('http://test.wapi.5lala.cn/user/company?token=32_KUs5rx8YNeflZ-KRCTEx4ulFWw1jrTi82Bx_veRSXUefvWRzLHUEKsUplrq57xlXI71TX0IBT_Nf6sSxGTqryw').then(res => {
                    console.log(res)
                })
            }
        },
        created() {
            this.QRCodeShow()
            this.test()
        }
    }
</script>
<style lang="less">
    #app {
        /*.fixed-content {*/
        /*    position: fixed;*/
        /*    top: 50%;*/
        /*    left: 50%;*/
        /*    transform: translate(-50%, -50%);*/
        /*    width: 100%;*/
        /*    height: 100%;*/
        /*    min-width: 1200px;*/
        /*    background: rgba(0, 0, 0, .5);*/
        /*}*/
    }
</style>



// WEBPACK FOOTER //
// src/App.vue